import React from 'react';
import classes from './Privacy.module.css'
import Toolbar from '../Toolbar/Toolbar'
import Footer from '../Footer/Footer'
import Logout from '../../containers/Login/Logout'

export default function Privacy(props) {

  return (
    <div >
     <Toolbar button={<Logout ></Logout>}></Toolbar>
    <div className = {classes.terms}>
    <div className={classes.terms_main} >Privacy Policy</div>
    <div className={classes.terms_body1}>
    <div className={classes.terms_center}>

These Privacy Policies have been updated as of October 1, 2021.
</div>
</div>
<div className={classes.terms_title}>

Overview
   </div>
<div className={classes.terms_body1}>
This Privacy Policy explains how Cryptologics-ai LLC collects, uses, and discloses information about you through its websites and other online products and services (collectively, the "Services") or when you otherwise interact with us.
   </div>
<div className={classes.terms_body1}>

We may change this Privacy Policy from time to time. If we make changes, we will notify you by revising the date at the top of the policy and, in some cases, we may provide you with additional notice (such as adding a statement to our homepage or sending you a notification). We encourage you to review the Privacy Policy whenever you access the Services or otherwise interact with us to stay informed about our information practices and the choices available to you.
   </div>
<div className={classes.terms_title}>

Collection of Information
   </div>
<div className={classes.text_bold}>

Information You Provide to
   </div>
<div className={classes.terms_body1}>

When you register for the Services, we ask you to provide certain information such as your name and email address and ask you to create a password. We also collect information when you participate in any interactive features of the Services (such as API keys, cryptocurrency exchange digital asset allocations), fill out a form, participate in a contest or promotion, make a purchase, apply for a job, communicate with us via third party social media sites, request customer support or otherwise communicate with us, or any other information you choose to provide to us.
   </div>

<div className={classes.text_bold}>

Information We Collect from Other Sources
   </div>
<div className={classes.terms_body1}>

We may obtain information from other sources and combine that with information we collect through our Services. For example, we may collect information about you and your cryptocurrency portfolios from third parties, including but not limited to cryptocurrency exchange platforms, mailing list providers and publicly-available sources.
   </div>
<div className={classes.text_bold}>

Information About Your Use of the Services
   </div>
<div className={classes.text_bold_itallic}>


Usage Information
   </div>
<div className={classes.terms_body1}>

We collect information about your use of the Services, such as cryptocurrency exchange balance information, deposits, withdrawals, and trades, and payment notifications.
   </div>

<div className={classes.text_bold_itallic}>

Automatically Collected Information
   </div>
<div className={classes.terms_body1}>

When you access or use our Services, we automatically collect information about you, including:
   </div>
<div className={classes.terms_body2}>
<div className={classes.text_bold}>

•	Log Information: </div> We collect log information about your use of the Services, including the type of browser you use, access times, pages viewed, your IP address and the page you visited before navigating to our Services.
   </div>
<div className={classes.terms_body2}>
<div className={classes.text_bold}>

•	Device Information: </div>We collect information about the computer or mobile device you use to access our Services, including the hardware model, operating system and version, unique device identifiers, and mobile network information.
   </div>
<div className={classes.terms_body2}>
<div className={classes.text_bold}>

•	Information Collected by Cookies and Other Tracking Technologies: </div>Like most online services, we may use cookies and other technologies, such as web beacons, web storage, and unique advertising identifiers, to collect information about your activity, browser, and device. Cookies are small data files stored on your hard drive or in device memory that help us improve our Services and your experience, see which areas and features of our Services are popular and count visits. Web beacons are electronic images that may be used in our Services or emails and help deliver cookies, count visits and understand usage and campaign effectiveness. For more information about cookies and how to disable them, please see "Your Choices" below.
   </div>
<div className={classes.terms_title}>

Use of Information
   </div>
<div className={classes.terms_body1}>

We use the information we collect to provide, maintain, and improve our services, such as to administer your account, and provide you with the services you request, and customize your experience with us. We may also use the information we collect to:
   </div>
<div className={classes.terms_body2}>

•	Send you technical notices, updates, security alerts and support and administrative messages and to respond to your comments, questions and customer service requests;
   </div>
<div className={classes.terms_body2}>

•	Communicate with you about products, services, offers, and events offered by Cryptologics-ai LLC and others, and provide news and information we think will be of interest to you;
</div>
<div className={classes.terms_body2}>

•	Monitor and analyze trends, usage and activities in connection with our Services;
</div>
<div className={classes.terms_body2}>

•	Detect, investigate and prevent fraudulent transactions and other illegal activities and protect the rights and property of Cryptologics-ai LLC and others;
</div>
<div className={classes.terms_body2}>

•	Personalize and improve the Services and provide advertisements, content or features that match user profiles or interests;
</div>
<div className={classes.terms_body2}>

•	Facilitate contests, sweepstakes and promotions and process and deliver entries and rewards;
</div>
<div className={classes.terms_body2}>

•	Comply with our legal obligations;
</div>
<div className={classes.terms_body2}>

•	Enforce, or otherwise use in connection with, any terms governing use of our Services; and
</div>
<div className={classes.terms_body2}>

•	Carry out any other purpose described to you at the time the information was collected.
</div>
<div className={classes.terms_title}>

Sharing of Information
   </div>
<div className={classes.terms_body1}>

We may share information about you as follows or as otherwise described in this Privacy Policy:
</div>
<div className={classes.terms_body2}>

•	With vendors, consultants and other service providers who need access to such information to carry out work on our behalf;
</div>
<div className={classes.terms_body2}>

•	In response to a request for information if we believe disclosure is in accordance with, or required by, any applicable law or legal process, including lawful requests by public authorities to meet national security or law enforcement requirements;
</div>
<div className={classes.terms_body2}>

•	If we believe your actions are inconsistent with our user agreements or policies, or to protect the rights, property and safety of Cryptologics-ai LLC or others;
</div>
<div className={classes.terms_body2}>

•	With other users of our Services with your consent;
</div>
<div className={classes.terms_body2}>

•	In connection with, or during negotiations of, any merger, sale of company assets, financing or acquisition of all or a portion of our business by another company;
</div>
<div className={classes.terms_body2}>

•	Between and among Crytpologics-ai LLC and our current and future parents, affiliates, subsidiaries and other companies under common control and ownership; and
</div>
<div className={classes.terms_body2}>

•	With your consent or at your direction.
</div>
<div className={classes.terms_body1}>

We may also share aggregated or de-identified information, which cannot reasonably be used to identify you.
</div>

<div className={classes.terms_title}>

Advertising and Analytics Services Provided by Others
</div>
<div className={classes.terms_body1}>

We may allow others to provide analytics services and serve advertisements on our behalf across the internet and in applications. These entities may use cookies, web beacons, device identifiers and other technologies to collect information about your use of the Services and other websites and applications, including your IP address, web browser, mobile network information, pages viewed, time spent on pages or in apps, links clicked and conversion information. This information may be used by Cryptologics-ai LLC and others to, among other things, analyze and track data, determine the popularity of certain content, deliver advertising and content targeted to your interests on our Services and other websites and better understand your online activity. For more information about interest-based ads, or to opt out of having your web browsing information used for behavioral advertising purposes, please visit www.aboutads.info/choices.
</div>

<div className={classes.terms_title}>

Data Retention
</div>

<div className={classes.terms_body1}>

We store the information we collect about you for as long as is necessary for the purpose(s) for which we originally collected it. We may retain certain information for legitimate business purposes or as required by law.
</div>
<div className={classes.terms_body1}>

Transfer of Information to the U.S. and Other Countries
</div>

<div className={classes.terms_body1}>

Cryptologics-ai LLC is based in the United States and we process and store information in the U.S. As such, we and our service providers may transfer your information to, or store or access it in, jurisdictions that may not provide equivalent levels of data protection as your home jurisdiction. We will take steps to ensure that your personal data receives an adequate level of protection in the jurisdictions in which we process it.
</div>
<div className={classes.terms_title}>

<div className={classes.text_bold}>

   Your Choices
</div>
</div>
<div className={classes.terms_body2}>
<div className={classes.text_bold}>

   Account Information
</div>
You may update, correct or delete information about you at any time by logging into your online account or emailing us at support@cryptologics-ai.com. If you wish to remove your API keys from our Services, you may do so by logging in to your account and removing them. We may retain certain information as required by law or for legitimate business purposes. We may also retain cached or archived copies of information about you for a certain period of time.
</div>

<div className={classes.terms_body2}>
<div className={classes.text_bold}>


   Cookies
</div>

Most web browsers are set to accept cookies by default. If you prefer, you can usually choose to set your browser to remove or reject browser cookies. Please note that if you choose to remove or reject cookies, this could affect the availability and functionality of our Services.
</div>
<div className={classes.terms_body2}>
<div className={classes.text_bold}>


   Promotional Communications
</div>
You may opt out of receiving promotional emails from Cryptologics-ai LLC by following the instructions in those emails or by emailing us at support@cryptologics-ai.com. If you opt out, we may still send you non-promotional emails, such as those about your account or our ongoing business relations.
</div>

<div className={classes.terms_body2}>
<div className={classes.text_bold}>


   Do Not Track Notice
</div>
Do Not Track (“DNT”) is a preference available in many web browsers which allows you to inform websites you visit that you do not want them collecting information about you. Cryptologics-ai LLC does not respond to DNT signals. For further details regarding DNT, visit donottrack.us.
</div>
    
       </div>
       <Footer></Footer>

 </div>
  );
}